'use client';

import React, { useEffect, useMemo } from 'react';
import { SpaServerHeader } from '@chewy/header-footer-react/dist/components/react/src/header/spa/spa-header';
import { SpaHeaderContext } from '@chewy/header-footer-react/dist/components/react/src/header/spa/spa-header.context';
import useEnv from '@/hooks/useEnv';

export const ClientHeader = (props: any) => {
  const envContext = useEnv();
  const chewyEnv = envContext?.chewyEnv || props?.env || 'prd';
  const spaHeaderContext = useMemo(
    () => ({
      pageType: 'home',
      baseURL: props.baseURL,
      type: 'header',
      env: chewyEnv,
      mountElemId: 'header'
    }),
    [props.baseURL, chewyEnv]
  );

  useEffect(() => {
    const scriptElem = document.createElement('script');
    scriptElem.src = '/app/headerfooterspa/header.js';
    scriptElem.async = true;
    scriptElem.defer = true;
    document.body.append(scriptElem);
  }, []);

  const newProps = { html: props.html, css: props.css, js: '' };

  return (
    <SpaHeaderContext.Provider value={spaHeaderContext}>
      <SpaServerHeader {...newProps} />
    </SpaHeaderContext.Provider>
  );
};
